import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import PageHeader from "../../core/App/PageHeader";
import { LoadingSpinner } from "../../core/components/LoadingSpinner";
import { RequireAuth, useMeQuery, useProductsQuery, UserRole } from 'legoland-sdk/dist/experimental';
import { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Button, Heading, TooltipOnHover } from 'tombac';
import { GuideIcon } from 'tombac-icons';
import { ContractAccessType, ContractStatus } from "../contractTypes";
import { CreateContractButton } from "../form/CreateContractButton";
import { ContractList } from "./ContractList";
import ContractsFilter from "./ContractsFilter";
import { getNearestPageSize } from "./Pagination";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const filterUrlParamsMapping = new Map([['searchValue', 'search'], ['statuses', 'status'], ['accessTypes', 'access'], ['products', 'product']]);
const pageUrlParamsMapping = new Map([['index', 'page'], ['size', 'pageSize']]);
const sortByUrlParamsMapping = new Map([['id', 'sortBy'], ['desc', 'desc']]);
function filterValidEnumValues(enumObject, values) {
  const validated = [];
  for (const value of values) {
    if (Object.values(enumObject).includes(value)) {
      validated.push(value);
    }
  }
  return validated;
}
function getUrlForParams(params, location, mapping) {
  const searchParams = new URLSearchParams(location.search);
  for (const [sourceName, urlName] of mapping.entries()) {
    searchParams.delete(urlName);
    const value = params && params[sourceName];
    if (value) {
      if (value instanceof Array) {
        for (const item of value) {
          searchParams.append(urlName, item);
        }
      } else {
        searchParams.set(urlName, value);
      }
    }
  }
  return `${location.pathname}?${searchParams.toString()}`;
}
export const ContractsListPage = () => {
  const products = useProductsQuery().data?.products;
  const location = useLocation();
  const history = useHistory();
  const meQuery = useMeQuery();
  const role = meQuery.data?.me?.role;
  const searchParams = new URLSearchParams(location.search);
  const filters = {
    searchValue: searchParams.get('search'),
    statuses: filterValidEnumValues(ContractStatus, searchParams.getAll('status')),
    accessTypes: filterValidEnumValues(ContractAccessType, searchParams.getAll('access')),
    products: searchParams.getAll('product').filter(fp => products?.find(p => p.id === fp))
  };
  const parsedPage = Number(searchParams.get('page'));
  const parsedPageSize = Number(searchParams.get('pageSize'));
  const page = {
    index: Number.isNaN(parsedPage) || parsedPage < 1 ? 0 : parsedPage - 1,
    size: Number.isNaN(parsedPageSize) ? 20 : getNearestPageSize(parsedPageSize)
  };
  const sortBy = useMemo(() => searchParams.has('sortBy') ? [{
    id: searchParams.get('sortBy'),
    desc: searchParams.get('desc') === 'true' ? true : false
  }] : [], [searchParams]);
  const handleFiltersChange = filters => {
    history.replace(getUrlForParams(filters, location, filterUrlParamsMapping));
  };
  const handlePageChange = page => {
    history.replace(getUrlForParams({
      ...page,
      index: page.index + 1
    }, location, pageUrlParamsMapping));
  };
  const handleSortByChange = sortBy => {
    history.replace(getUrlForParams(sortBy && sortBy[0], location, sortByUrlParamsMapping));
  };
  useEffect(() => {
    handleFiltersChange({
      ...filters,
      statuses: [ContractStatus.Active]
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(PageHeader, {
      transparent: true,
      "data-sentry-element": "PageHeader",
      "data-sentry-source-file": "ContractsListPage.tsx",
      "data-sentry-element": "PageHeader",
      children: [/*#__PURE__*/_jsxs(Box, {
        $display: "flex",
        $alignItems: "center",
        $mb: "2sp",
        "data-sentry-element": "Box",
        "data-sentry-source-file": "ContractsListPage.tsx",
        "data-sentry-element": "Box",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h1",
          level: 3,
          $mb: "0sp",
          "data-sentry-element": "Heading",
          "data-sentry-source-file": "ContractsListPage.tsx",
          "data-sentry-element": "Heading",
          children: "Contracts"
        }), /*#__PURE__*/_jsxs(RequireAuth, {
          role: [UserRole.Admin, UserRole.Distributor],
          "data-sentry-element": "RequireAuth",
          "data-sentry-source-file": "ContractsListPage.tsx",
          "data-sentry-element": "RequireAuth",
          children: [/*#__PURE__*/_jsx(CreateContractButton, {
            role: role,
            $m: "0 3sp",
            "data-sentry-element": "CreateContractButton",
            "data-sentry-source-file": "ContractsListPage.tsx",
            "data-sentry-element": "CreateContractButton"
          }), /*#__PURE__*/_jsx(TooltipOnHover, {
            content: "Open contracts creation guide",
            placement: "top",
            "data-sentry-element": "TooltipOnHover",
            "data-sentry-source-file": "ContractsListPage.tsx",
            "data-sentry-element": "TooltipOnHover",
            children: /*#__PURE__*/_jsx(Button, {
              as: "a",
              href: "https://support.move.tomtom.com/contracts-creation-guide/",
              shape: "circle",
              target: "_blank",
              variant: "flat",
              "data-sentry-element": "Button",
              "data-sentry-source-file": "ContractsListPage.tsx",
              "data-sentry-element": "Button",
              children: /*#__PURE__*/_jsx(GuideIcon, {
                "data-sentry-element": "GuideIcon",
                "data-sentry-source-file": "ContractsListPage.tsx",
                "data-sentry-element": "GuideIcon"
              })
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(ContractsFilter, {
        filters: filters,
        onChange: handleFiltersChange,
        "data-sentry-element": "ContractsFilter",
        "data-sentry-source-file": "ContractsListPage.tsx",
        "data-sentry-element": "ContractsFilter"
      })]
    }), products ? /*#__PURE__*/_jsx(ContractList, {
      filters: filters,
      page: page,
      onPageChange: handlePageChange,
      onSortByChange: handleSortByChange,
      sortBy: sortBy
    }) : /*#__PURE__*/_jsx(LoadingSpinner, {})]
  });
};